import { TApiResponse } from '@/common/types/response';

import { TCustomsOrgansOnBorderItem } from '../../types/common-aggregated';
import { TVedCommonState } from './types';

export function setCountriesTree(state: TVedCommonState, response: TApiResponse<TVedCommonState['countriesTree']>) {
  state.countriesTree = response.data;
}

export function setRegionsRfTree(state: TVedCommonState, response: TApiResponse<TVedCommonState['regionsRfTree']>) {
  state.regionsRfTree = response.data;
}

export function setCustomsOrgansOnBorder(state: TVedCommonState, response: TApiResponse<TCustomsOrgansOnBorderItem[]>) {
  state.customsOrgansOnBorder = response?.data ?? [];
}

export function setCustomsOrgansOnBorderTree(
  state: TVedCommonState,
  response: TApiResponse<TVedCommonState['customsOrgansOnBorderTree']>,
) {
  state.customsOrgansOnBorderTree = response?.data ?? [];
}
